import axios from './../api' // 倒入 api

// 获取司机请假列表
const getDriverLeaveList = (data) => {
  return axios({
    url: '/api/leave/list',
    method: 'POST',
    data,
  })
}

//新增司机请假记录
const addDriverLeave = (data) => {
  return axios({
    url: '/api/leave',
    method: 'POST',
    data,
  })
}

//获取请假详情
const getLeaveDetail = (leaveId) => {
  return axios({
    url: `/api/leave/${leaveId}`,
    method: 'GET',
  })
}

//编辑请假详情
const modifyDriverLeave = (data) => {
  return axios({
    url: '/api/leave',
    method: 'PUT',
    data,
  })
}

//删除请假详情
const deleteLeave = (leaveId) => {
  return axios({
    url: `/api/leave/${leaveId}`,
    method: 'DELETE',
  })
}

//获取维修列表
const getRepaireList = (data) => {
  return axios({
    url: `/api/repair/list`,
    method: 'POST',
    data,
  })
}

//新增维修记录
const addRepair = (data) => {
  return axios({
    url: `/api/repair`,
    method: 'POST',
    data,
  })
}

//修改维修记录
const modifyRepair = (data) => {
  return axios({
    url: `/api/repair`,
    method: 'PUT',
    data,
  })
}
// 获取维修流程
const getCheckLink = (params) => {
  return axios({
    url: '/api/car-service/check-link',
    method: 'GET',
    params,
  })
}
// 获取维修流程
const getAccidentDetailId = (params) => {
  return axios({
    url: '/api/accident/info',
    method: 'GET',
    params,
  })
}
//获取维修记录
const getRepairDetail = (repairId) => {
  return axios({
    url: `/api/repair/${repairId}`,
    method: 'GET',
  })
}

//删除维修记录
const delRepair = (repairId) => {
  return axios({
    url: `/api/repair/${repairId}`,
    method: 'DELETE',
  })
}

//获取保养列表
const getMaintainList = (data) => {
  return axios({
    url: `/api/maintain/list`,
    method: 'POST',
    data,
  })
}

//删除保养记录
const delMaintain = (maintainId) => {
  return axios({
    url: `/api/maintain/${maintainId}`,
    method: 'DELETE',
  })
}

//登记保养记录
const addMaintain = (data) => {
  return axios({
    url: `/api/maintain`,
    method: 'POST',
    data,
  })
}

//编辑保养记录
const modifyMaintain = (data) => {
  return axios({
    url: `/api/maintain`,
    method: 'PUT',
    data,
  })
}

//获取保养记录详情
const getMaintain = (maintainId) => {
  return axios({
    url: `/api/maintain/${maintainId}`,
    method: 'GET',
  })
}

//获取年检记录
const getMotList = (data) => {
  return axios({
    url: `/api/mot/list`,
    method: 'POST',
    data,
  })
}

//获取年检记录详情
const getMotDetail = (motId) => {
  return axios({
    url: `/api/mot/${motId}`,
    method: 'GET',
  })
}

//删除年检记录
const delMot = (motId) => {
  return axios({
    url: `/api/mot/${motId}`,
    method: 'DELETE',
  })
}

//提交年检记录
const addMot = (data) => {
  return axios({
    url: `/api/mot`,
    method: 'POST',
    data,
  })
}

//获取年检记录详情
const modifyMot = (data) => {
  return axios({
    url: `/api/mot`,
    method: 'PUT',
    data,
  })
}

//获取加油登记列表
const getFuelList = (data) => {
  return axios({
    url: `/api/fuel/list`,
    method: 'POST',
    data,
  })
}

//获取加油登记详情
const getFuelDetail = (fuelId) => {
  return axios({
    url: `/api/fuel/${fuelId}`,
    method: 'GET',
  })
}

//加油登记
const addFuel = (data) => {
  return axios({
    url: `/api/fuel`,
    method: 'POST',
    data,
  })
}

//修改加油登记记录
const modifyFuel = (data) => {
  return axios({
    url: `/api/fuel`,
    method: 'PUT',
    data,
  })
}

//删除加油登记记录
const delFuel = (fuelId) => {
  return axios({
    url: `/api/fuel/${fuelId}`,
    method: 'DELETE',
  })
}

//获取保险记录列表
const getInsureList = (data) => {
  return axios({
    url: `/api/insure/list`,
    method: 'POST',
    data,
  })
}

//获取保险记录详情
const getInsureDetail = (insureId) => {
  return axios({
    url: `/api/insure/${insureId}`,
    method: 'GET',
  })
}

//新增保险记录
const addInsure = (data) => {
  return axios({
    url: `/api/insure`,
    method: 'POST',
    data,
  })
}

//修改保险记录
const modifyInsure = (data) => {
  return axios({
    url: `/api/insure`,
    method: 'PUT',
    data,
  })
}

//删除保险记录
const delInsure = (insureId) => {
  return axios({
    url: `/api/insure/${insureId}`,
    method: 'DELETE',
  })
}

//获取费用列表
const getFeeList = (data) => {
  return axios({
    url: `/api/fee/list`,
    method: 'POST',
    data,
  })
}
//获取费用详情
const getFeeDetail = (feeId) => {
  return axios({
    url: `/api/fee/${feeId}`,
    method: 'GET',
  })
}

//新建费用记录
const addFee = (data) => {
  return axios({
    url: `/api/fee`,
    method: 'POST',
    data,
  })
}

//修改费用记录
const modifyFee = (data) => {
  return axios({
    url: `/api/fee`,
    method: 'PUT',
    data,
  })
}

//删除保险记录
const delFee = (feeId) => {
  return axios({
    url: `/api/fee/${feeId}`,
    method: 'DELETE',
  })
}
// * 违章
//违章列表
const getCarViolateList = (params) => {
  return axios({
    url: `/api/car-violate/list`,
    params,
  })
}
//违章登记
const carViolateSubmit = (data) => {
  return axios({
    url: `/api/car-violate/submit`,
    method: 'POST',
    data,
  })
}
//违章编辑
const editViolateSubmit = (data) => {
  return axios({
    url: `/api/car-violate/edit`,
    method: 'POST',
    data,
  })
}
//违章详情
const getViolateDetail = (violateId) => {
  return axios({
    url: `/api/car-violate/info/${violateId}`,
    method: 'get',
  })
}
//违章详情
const delViolate = (violateId) => {
  return axios({
    url: `/api/car-violate/del//${violateId}`,
    method: 'delete',
  })
}
// * 事故
//事故列表
const getAccidentList = (params) => {
  return axios({
    url: `/api/accident/list`,
    params,
  })
}

//获取事故详情
const getAccidentDetail = (accidentId) => {
  return axios({
    url: `/api/accident/${accidentId}`,
    method: 'GET',
  })
}

//事故登记
const addAccidentSubmit = (data) => {
  return axios({
    url: `/api/accident/submit`,
    method: 'POST',
    data,
  })
}
//事故登记
const editAccidentSubmit = (data) => {
  return axios({
    url: `/api/accident/edit`,
    method: 'POST',
    data,
  })
}
//删除事故
const delAccident = (accidentId) => {
  return axios({
    url: `/api/del/accident/${accidentId}`,
    method: 'DELETE',
  })
}

// * 私家车
//私家车列表
const getPrivateCarList = (params) => {
  return axios({
    url: `/api/pc/private/car/list`,
    params,
  })
}

//私家车补贴设置
const setPrivateCarSubsidy = (data) => {
  return axios({
    url: `/api/private/car/subsidy/set`,
    method: 'POST',
    data,
  })
}

//私家车核实
const privateCarVerify = (params) => {
  return axios({
    url: `/api/private/car/verify`,
    params,
  })
}

//删除私家车
const delPrivateCar = (privateCarId) => {
  return axios({
    url: `/api/private/car/${privateCarId}`,
    method: 'DELETE',
  })
}

export default {
  getDriverLeaveList,
  addDriverLeave,
  getLeaveDetail,
  modifyDriverLeave,
  deleteLeave,
  getRepaireList,
  addRepair,
  modifyRepair,
  getRepairDetail,
  delRepair,
  getMaintainList,
  delMaintain,
  addMaintain,
  modifyMaintain,
  getMaintain,
  getMotList,
  getMotDetail,
  addMot,
  modifyMot,
  delMot,
  getFuelList,
  getFuelDetail,
  addFuel,
  modifyFuel,
  delFuel,
  getInsureList,
  getInsureDetail,
  addInsure,
  modifyInsure,
  delInsure,
  getFeeList,
  getPrivateCarList,
  addAccidentSubmit,
  getAccidentDetail,
  getAccidentList,
  delAccident,
  getFeeDetail,
  addFee,
  modifyFee,
  delFee,
  setPrivateCarSubsidy,
  delPrivateCar,
  privateCarVerify,
  getCheckLink,
  getAccidentDetailId,
  editAccidentSubmit,
  getCarViolateList,
  carViolateSubmit,
  getViolateDetail,
  delViolate,
  editViolateSubmit,
}
